<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <BaseInputText v-model="time" v-bind="$attrs" readonly v-on="on" />
    </template>
    <v-time-picker v-if="menu" v-model="time" full-width>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="cancel" icon fab small>
        <v-icon color="error">mdi-close</v-icon>
      </v-btn>
      <v-btn text color="primary" @click="save" icon fab small>
        <v-icon color="success">mdi-check</v-icon>
      </v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
import BaseInputText from "./BaseInputText";

export default {
  name: "BaseInputTime",
  inheritAttrs: false,
  comonents: { BaseInputText },
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      time: this.value,
      menu: false
    };
  },
  methods: {
    cancel() {
      this.menu = false;
    },
    save() {
      this.$refs.menu.save(this.time);
      this.$emit("input", this.time);
    }
  },
  watch: {
    value() {
      this.time = this.value;
    }
  }
};
</script>
